// Title
export const TITLE='Freshokartz';

// Languages
export const LANGUAGE='LANGUAGE';
export const ENGLISH='ENGLISH';
export const HINDI='HINDI';

// Menus
export const HOME='Home';
export const HOW_IT_WORKS="HOW_IT_WORKS";
export const ABOUT="ABOUT";
export const PARTNER="PARTNER";
export const TEAM="TEAM";
export const CONTACT="CONTACT";

export const HERO_TITLE="HERO_TITLE";
export const HERO_SUBTITLE="HERO_SUBTITLE";

export const STATS_CENTRE="STATS_CENTRE";
export const STATS_FARMERS="STATS_FARMERS";
export const STATS_LOCATION="STATS_LOCATION";
export const STATS_CUSTOMER="STATS_CUSTOMER";
export const STATS_PARTNERS="STATS_PARTNERS";
export const STATS_PRODUCTS="STATS_PRODUCTS";

export const NEWS_SUBTITLE="NEWS_SUBTITLE";
export const NEWS_TITLE="NEWS_TITLE";

export const READ_ARTICLE="READ_ARTICLE";

export const INPUT="INPUT";
export const INPUT_DESCRIPTION="INPUT_DESCRIPTION";
export const INPUT_FEATURE_1="INPUT_FEATURE_1";
export const INPUT_FEATURE_2="INPUT_FEATURE_2";
export const INPUT_FEATURE_3="INPUT_FEATURE_3";
export const INPUT_FEATURE_4="INPUT_FEATURE_4";
export const INPUT_FEATURE_5="INPUT_FEATURE_5";
export const INPUT_FEATURE_6="INPUT_FEATURE_6";


export const OUTPUT="OUTPUT";
export const OUTPUT_DESCRIPTION="OUTPUT_DESCRIPTION";
export const OUTPUT_FEATURE_1="OUTPUT_FEATURE_1";
export const OUTPUT_FEATURE_2="OUTPUT_FEATURE_2";
export const OUTPUT_FEATURE_3="OUTPUT_FEATURE_3";
export const OUTPUT_FEATURE_4="OUTPUT_FEATURE_4";
export const OUTPUT_FEATURE_5="OUTPUT_FEATURE_5";
export const OUTPUT_FEATURE_6="OUTPUT_FEATURE_6";


export const CROP_ADVISORY="CROP_ADVISORY";
export const CROP_ADVISORY_DESCRIPTION="CROP_ADVISORY_DESCRIPTION";
export const CROP_ADVISORY_FEATURE_1="CROP_ADVISORY_FEATURE_1";
export const CROP_ADVISORY_FEATURE_2="CROP_ADVISORY_FEATURE_2";
export const CROP_ADVISORY_FEATURE_3="CROP_ADVISORY_FEATURE_3";
export const CROP_ADVISORY_FEATURE_4="CROP_ADVISORY_FEATURE_4";
export const CROP_ADVISORY_FEATURE_5="CROP_ADVISORY_FEATURE_5";
export const CROP_ADVISORY_FEATURE_6="CROP_ADVISORY_FEATURE_6";

export const FINANCIAL="FINANCIAL";
export const FINANCIAL_DESCRIPTION="FINANCIAL_DESCRIPTION";
export const FINANCIAL_FEATURE_1="FINANCIAL_FEATURE_1";
export const FINANCIAL_FEATURE_2="FINANCIAL_FEATURE_2";
export const FINANCIAL_FEATURE_3="FINANCIAL_FEATURE_3";
export const FINANCIAL_FEATURE_4="FINANCIAL_FEATURE_4";
export const FINANCIAL_FEATURE_5="FINANCIAL_FEATURE_5";
export const FINANCIAL_FEATURE_6="FINANCIAL_FEATURE_6";


export const CONTACT_US="CONTACT_US";
export const ADDRESS_1="ADDRESS_1";
export const ADDRESS_2="ADDRESS_2";
export const ADDRESS_3="ADDRESS_3";
export const PHONE="PHONE";
export const EMAIL="EMAIL";
